import type { Migration, MigrationRun } from './api/migrationsClient';

/** Who started a run: their email, which every run records. */
export const runnerName = (run: MigrationRun) => run.startedBy?.email || 'Unknown';

/** The newer of the last real run and the last dry run. */
export const lastRunOf = (m: Migration): MigrationRun | null => {
  const runs = [m.lastApply, m.lastDryRun].filter((r): r is MigrationRun => !!r);
  if (runs.length === 0) return null;
  return runs.reduce((a, b) => ((a.startedAt ?? '') >= (b.startedAt ?? '') ? a : b));
};
